import { render, staticRenderFns } from "./PaymentMethodCheckout.vue?vue&type=template&id=0a3ed4f2"
import script from "./PaymentMethodCheckout.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports